// ─── Template : LISTE DÉROULANTE (Core) ───────────────────────────
// Principe app-wide posé par Cédric le 11/08 : un choix parmi N valeurs se
// fait par une LISTE DÉROULANTE avec icône et texte, pas par une rangée de
// puces. Motif : au-delà de deux ou trois options, les puces débordent sur
// plusieurs lignes, tronquent les libellés et rendent l'écran illisible —
// c'est ce qui arrivait aux enveloppes et aux catégories de My Finance.
//
//   <SelecteurListe titre="Enveloppe" emoji="💰" valeur={budgetId}
//     options={[{ id, label, emoji, sous }]} onChange={setBudgetId} />
//
// N'INVENTE RIEN : assemble `ChampBouton` (le champ en lecture) et
// `CalqueChoix`/`LigneChoix` (le calque de sélection), qui existaient déjà et
// obéissent aux règles de modale de l'app. Une <Feuille> ne peut pas ouvrir
// une seconde <Feuille> — d'où le calque, cf. CalqueChoix.
//
// `avecVide` ajoute une entrée « — » pour retirer la valeur : sans elle, un
// choix fait ne peut plus être défait, ce qui piège l'utilisateur.
import React, { useMemo, useState } from 'react';
import ChampBouton from './ChampBouton';
import CalqueChoix, { LigneChoix } from './CalqueChoix';

export default function SelecteurListe({
  titre, emoji, aide, valeur, options = [], onChange,
  placeholder = '—', avecVide = false, libelleVide = '—',
  enErreur, estompe, style,
}) {
  const [ouvert, setOuvert] = useState(false);
  const choisie = useMemo(
    () => options.find(o => o.id === valeur) || null,
    [options, valeur],
  );

  const choisir = (id) => { onChange?.(id); setOuvert(false); };

  return (
    <>
      <ChampBouton
        icone={choisie?.emoji}
        valeur={choisie?.label}
        placeholder={placeholder}
        onPress={() => setOuvert(true)}
        enErreur={enErreur} estompe={estompe} style={style}
      />
      <CalqueChoix visible={ouvert} titre={titre} emoji={emoji} aide={aide}
        onFermer={() => setOuvert(false)}>
        {avecVide && (
          <LigneChoix libelle={libelleVide} onPress={() => choisir(null)} />
        )}
        {options.map(o => (
          <LigneChoix key={String(o.id)}
            libelle={o.emoji ? `${o.emoji} ${o.label}` : o.label}
            sous={o.sous}
            onPress={() => choisir(o.id)} />
        ))}
      </CalqueChoix>
    </>
  );
}
